import { render, staticRenderFns } from "./ModalEditAdmin.vue?vue&type=template&id=89a81340"
import script from "./ModalEditAdmin.vue?vue&type=script&lang=js"
export * from "./ModalEditAdmin.vue?vue&type=script&lang=js"
import style0 from "./ModalEditAdmin.vue?vue&type=style&index=0&id=89a81340&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports